// Địa Đồ `world.map` (UI_SPEC §18.2), P0: vùng Thanh Hư / Đông Hoang với 2 vùng tài nguyên. Chạm
// node vùng → cửa sổ giao Lịch Luyện (sản vật, thanh Trữ Lượng). Số chính: dòng caption.
import type { JSX } from 'preact';
import { t } from '@i18n/t';
import { TRIAL_ZONES } from '@data/content/zones';
import { cultivation } from '@state/modules/cultivation';
import { openWindow } from '@state/modules/ui';

export function MapScreen(): JSX.Element {
  const c = cultivation.value;
  const here = c.idle.mode === 'trial' ? c.idle.trialZoneId : null;
  return (
    <>
      <div class="ht-caption" data-id="caption">
        <b>{t('region.thanhHu.name')}</b>
        <span>{here ? t('ui.map.trialAt', { zone: t(`${here}.name`) }) : t('ui.map.idle')}</span>
      </div>
      <div class="map-paper" aria-hidden="true" />
      <div class="map-node hub" style={{ left: '200px', top: '250px' }}>
        <i />
        <span>{t('ui.map.hub')}</span>
      </div>
      {TRIAL_ZONES.map((z) => (
        <button
          type="button"
          key={z.id}
          class={here === z.id ? 'map-node on' : 'map-node'}
          data-id={`map-${z.id}`}
          style={{ left: `${z.node.x}px`, top: `${z.node.y}px` }}
          onClick={() => openWindow({ kind: 'zone', zoneId: z.id })}
        >
          <i />
          <span>{t(`${z.id}.name`)}</span>
        </button>
      ))}
    </>
  );
}
